<template>
  <div v-if="refStepsSetting" class="referral-settings">
    <div v-if="company.root_company.id === 7496" class="rewards-container">
      <li>
        <p>{{ $t('admin.job.editor.label.adpReferralRewardMessage') }}</p>
      </li>
      <li>
        <p>{{ $t('admin.job.editor.label.adpReferralTipMessage') }}</p>
      </li>
    </div>
    <div v-else class="rewards-container">
      <p v-if="!hiddenTitle" class="rewards-title">
        {{ isFosunCompany ? $t('jobDetail.welcomeToRecommend') : $t('jobDetail.referralRewards') }}
      </p>
      <ReferralInfoList
        class="referral-info-list"
        :isInLine="isInLine"
        :isFosunCompany="isFosunCompany"
        :isCompanyEmployee="isCompanyEmployee"
        :hasCustomReferralWord="hasCustomReferralWord"
        :usePointsReplaceOthers="isHiddenRewards || isUsePointReplacePayroll"
        :isADPCompany="isADPCompany"
        :isCoachCompany="isCoachCompany"
        :stepSetting="refStepsSetting"
      />
    </div>
    <div v-if="customizationRewardsRules">
      <p class="referral-tip-message">{{ customizationRewardsRules.tips }}</p>
      <p class="view_referral_rules">{{ customizationRewardsRules.click_label }}</p>
    </div>
  </div>
</template>

<script>
import ReferralInfoList from './referralInfoList.vue'

export default {
  components: {
    ReferralInfoList
  },
  props: {
    isInLine: {
      type: Boolean,
      default: false
    },
    refStepsSetting: {
      required: true
    },
    company: {
      required: true,
      type: Object
    },
    hasCustomReferralWord: {
      type: Boolean,
      default: false
    },
    isHiddenRewards: {
      type: Boolean,
      default: false
    },
    isUsePointReplacePayroll: {
      type: Boolean,
      default: false
    },
    isADPCompany: {
      type: Boolean,
      default: false
    },
    isCoachCompany: {
      type: Boolean,
      default: false
    },
    isFosunCompany: {
      type: Boolean,
      default: false
    },
    isCompanyEmployee: {
      type: Boolean,
      default: false
    },
    customizationRewardsRules: {
      type: Object,
      required: false,
      default: () => {}
    },
    hiddenTitle: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.referral-settings {
  .rewards-container {
    .referral-info {
      ::v-deep {
        ul {
          list-style: disc;
        }
      }
    }
  }
}
</style>
